__turbopack_context__.v({
  "ad-info__id": "index-module-scss-module__UODeTG__ad-info__id",
  "ad-info__listing-info": "index-module-scss-module__UODeTG__ad-info__listing-info",
  "ad-info__top-caption-wrapper": "index-module-scss-module__UODeTG__ad-info__top-caption-wrapper",
  "buyButton": "index-module-scss-module__UODeTG__buyButton",
  "campaign-banner-container": "index-module-scss-module__UODeTG__campaign-banner-container",
  "location": "index-module-scss-module__UODeTG__location",
  "locationText": "index-module-scss-module__UODeTG__locationText",
  "paypal-section": "index-module-scss-module__UODeTG__paypal-section",
  "price": "index-module-scss-module__UODeTG__price",
  "sold-box": "index-module-scss-module__UODeTG__sold-box",
  "title": "index-module-scss-module__UODeTG__title",
  "useful-links-wrapper": "index-module-scss-module__UODeTG__useful-links-wrapper",
});
